/**
 * 主入口
 */
document.addEventListener("DOMContentLoaded", function () {
    

let sp_price1 = 17.49;
let sp_price2 = 34.99;

  const $priceDom = $('#sp_price1');
  const $cPriceDom = $('#sp_price2');
  const $offPriceDom = $('.price-group .sp-p');
  const $numDom = $('#calcNumber');

  const productData = window.product || [];

  /** 获取当前选中的变量 */
  function getCur() {
    const opts = {
      option1: $('#sp-opt-group1 div.active').attr('data-val'),
      option2: $('#sp-opt-group2 div.active').attr('data-val'),
      option3: $('#sp-opt-group3 div.active').attr('data-val')
    };

    return productData.find(item => {
      return (!opts.option1 || item.option1 == opts.option1) &&
        (!opts.option2 || item.option2 == opts.option2) &&
        (!opts.option3 || item.option3 == opts.option3);
    });
  }


  // 绑定选项点击事件
  $(document).on('click', '.sp-option', function () {
    setTimeout(changePrice, 10);
  });

  $('.sp_buy_now').click(function () {

    let num = $numDom.val();
    let id = getCur().id;
    window.location.href = '/cart/' + id + ':' + num;

  });

  console.log('页面加载完成');

  // 图片预加载列表
  let spImgList = [
    // 在这里添加需要预加载的图片路径
  ];


  // 页面缩放适配
  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener("resize", (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            if (document.body.clientWidth <= 1080) {
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            } else {
              const scale = document.body.clientWidth / 1920;
              $("#root").css("zoom", scale);
            }
          }, 100);
        };
      })());
    });
  }

  mainRender();

  // 滚动固定头部
  function updatePcStickyHeader() {
    if (document.body.clientWidth <= 1080) return;
    const zoomValue = parseFloat($("div#root").css("zoom")) || 1;
    const threshold = 80 * zoomValue;
    if ($(window).scrollTop() > threshold) {
      $(".sp_header-wrap").addClass("sp-fixed");
    //   $(".hide-for-sticky").addClass("sp-hidden");
    } else {
      $(".sp_header-wrap").removeClass("sp-fixed");
    //   $(".hide-for-sticky").removeClass("sp-hidden");
    }
  }
  updatePcStickyHeader();
  $(window).scroll(function () {
    updatePcStickyHeader();
  });

  // 菜单交互
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask, .sp-close-btn").click(function (e) {
    $(".sp-menu-mask").hide();
  });

  function handleShoppingLinkClick(event) {
    const link = event.target.closest('a[href="#shopping"]');
    if (!link) return;

    event.preventDefault();

    const targetElement = document.getElementById("shopping");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 50 : 0;
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });

      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
    }
  }

  document.addEventListener('click', handleShoppingLinkClick);


  // 文本渐出动画（按模块分组，依次动画）
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }

  // 懒加载图片
  function lazyLoadImages() {
    const images = document.querySelectorAll(".lazy-load");
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          if (dataSrc) {
            image.src = dataSrc;
          }
          lazyLoadObserver.unobserve(image);
        }
      });
    }, config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image);
    });
  }

  lazyLoadImages();

  $(function () {
    // 判断是否为移动端
    function isMobile() {
      return document.body.clientWidth <= 1060;
    }

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      if (isMobile()) {
        $(".sp-mobile .sp-cart .sp-num").show();
        $(".sp-mobile .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-mobile .sp-cart").removeClass("on");
        }, 500);
      } else {
        $(".sp_header.sp-pc .sp-cart .sp-num").show();
        $(".sp_header.sp-pc .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp_header.sp-pc .sp-cart").removeClass("on");
        }, 500);
      }
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
    });

    let initNum = 0;

    $(".product-part .cart-btn").click(function () {
      // let spNum = $("#calcNumber")[0].value;
      // initNum += Number(spNum);

      // // 更新购物车数量
      // if (isMobile()) {
      //   $(".sp-mobile .cardNum").each(function () {
      //     $(this).html(initNum);
      //   });
      // } else {
      //   $(".sp-pc .cardNum").each(function () {
      //     $(this).html(initNum);
      //   });
      // }
      // $(".cardNum").removeClass("sp-gray");
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            // $("#cardNum").html(result.item_count);
            $(".cardNum").each(function () {
              $(this).html(result.item_count);
              $(this).removeClass("sp-gray");

              $(this).css("background-color", "#cf0101");
            });
          });
        },
        dataType: "json",
      });

      var imgs = $(".sp-img-p.active");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part").append(flyer);

        // 获取图片在视口中的位置
        var imgRect = $img[0].getBoundingClientRect();
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",
          top: imgRect.top,
          left: imgRect.left,
          "z-index": 99,
        });

        let finish, targetTop, targetLeft;

        if (isMobile()) {
          // 移动端：飞向底部固定按钮中的购物车
          finish = $(".sp-btn-style2.sp-mobile .sp-cart");
          if (finish.length > 0) {
            targetTop = $(".sp-btn-style2")[0].offsetTop;
            targetLeft =
              $(".sp-btn-style2 .sp-right")[0].offsetLeft + finish.width() + 20;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
          $(flyer).animate(
            {
              top: targetTop,
              left: targetLeft,
              width: 50,
              height: 50,
              opacity: 0.4,
            },
            500,
            "linear",
            function () {
              $(this).animate(
                {
                  width: 0,
                  height: 0,
                  opacity: 0,
                },
                0,
                function () {
                  $(this).detach();
                }
              );
            }
          );
        } else {
          // PC端：飞向header中的购物车
          finish = $(".sp_header.sp-pc .sp-cart");

          if (finish.length > 0) {
            var cartRect = finish[0].getBoundingClientRect();
            $(flyer).animate(
              {
                top: cartRect.top + cartRect.height / 2,
                left: cartRect.left + cartRect.width / 2,
                width: 50,
                height: 50,
                opacity: 0.4,
              },
              500,
              "linear",
              function () {
                $(this).animate(
                  {
                    width: 0,
                    height: 0,
                    opacity: 0,
                  },
                  0,
                  function () {
                    $(this).detach();
                  }
                );
              }
            );
          } else {
            $(flyer).detach();
          }
        }
      });
    });
  });
});


// ==================== TopBar 模块 JS（AI 生成） ====================
// 顶部公告栏轮播
new Swiper(".sp-swiper-fade", {
  spaceBetween: 10,
  effect: "fade",
  autoplay: {
    disableOnInteraction: false,
    delay: 2000,
  },
  speed: 2000,
});

new Swiper(".sp-part3 .sp-swiper-part3", {
  autoplay: {
    disableOnInteraction: false,
    delay: 3500,
  },
  loop: true,
  speed: 600,
  pagination: {
    el: ".sp-part3 .sp-pagination",
    clickable: true,
  },
});

new Swiper(".sp-part5.sp-mobile .sp-swiper-part5", {
  autoplay: {
    disableOnInteraction: false,
    delay: 3500,
  },
  loop: true,
  speed: 600,
  pagination: {
    el: ".sp-part5 .sp-pagination-part5",
    clickable: true,
  },
});

new Swiper(".sp-part6.sp-mobile .sp-swiper-part6", {
  autoplay: {
    disableOnInteraction: false,
    delay: 3500,
  },
  loop: false,
  speed: 600,
  pagination: {
    el: ".sp-part6 .sp-pagination-part6",
    clickable: true,
  },
});

new Swiper(".sp-part4.sp-pc .sp-swiper-part4", {
  autoplay: {
    disableOnInteraction: false,
    delay: 3500,
  },
  loop: false,
  speed: 600,
  pagination: {
    el: ".sp-part4 .sp-pagination-part4",
    clickable: true,
  },
});

const part5PcArrowTopList = [150, 256, 360, 465, 570];
const part5PcArrow = document.querySelector(".sp-part5.sp-pc .sp-part5-active-arrow");
const part5PcFeatureTitles = Array.from(document.querySelectorAll(".sp-part5.sp-pc .sp-part5-feature-title"));
const part5PcFeatureDescs = Array.from(document.querySelectorAll(".sp-part5.sp-pc .sp-part5-feature-desc"));

function setPart5PcActive(index) {
  part5PcFeatureTitles.forEach((element, itemIndex) => {
    if (itemIndex === index) {
      element.classList.add("sp-part5-feature-active");
    } else {
      element.classList.remove("sp-part5-feature-active");
    }
  });

  part5PcFeatureDescs.forEach((element, itemIndex) => {
    if (itemIndex === index) {
      element.classList.add("sp-part5-feature-active");
    } else {
      element.classList.remove("sp-part5-feature-active");
    }
  });

  if (part5PcArrow && typeof part5PcArrowTopList[index] !== "undefined") {
    part5PcArrow.style.top = `${part5PcArrowTopList[index]}px`;
  }
}

const part5PcSwiper = new Swiper(".sp-part5.sp-pc .sp-swiper-part5-pc", {
  autoplay: {
    disableOnInteraction: false,
    delay: 3500,
  },
  loop: true,
  effect: "fade",
  speed: 600,
  on: {
    init(swiper) {
      setPart5PcActive(swiper.realIndex);
    },
    slideChange(swiper) {
      setPart5PcActive(swiper.realIndex);
    },
  },
});

part5PcFeatureTitles.forEach((element, index) => {
  element.addEventListener("click", () => {
    part5PcSwiper.slideToLoop(index);
    setPart5PcActive(index);
  });
});

part5PcFeatureDescs.forEach((element, index) => {
  element.addEventListener("click", () => {
    part5PcSwiper.slideToLoop(index);
    setPart5PcActive(index);
  });
});

const part7MobileArrowTopList = [170, 294, 415, 536, 659];
const part7MobileArrow = document.querySelector(".sp-part7.sp-mobile .sp-part7-active-arrow");
const part7MobileFeatureTitles = Array.from(document.querySelectorAll(".sp-part7.sp-mobile .sp-part7-feature-title"));
const part7MobileFeatureDescs = Array.from(document.querySelectorAll(".sp-part7.sp-mobile .sp-part7-feature-desc"));

function setPart7MobileActive(index) {
  part7MobileFeatureTitles.forEach((element, itemIndex) => {
    if (itemIndex === index) {
      element.classList.add("sp-part7-feature-active");
    } else {
      element.classList.remove("sp-part7-feature-active");
    }
  });

  part7MobileFeatureDescs.forEach((element, itemIndex) => {
    if (itemIndex === index) {
      element.classList.add("sp-part7-feature-active");
    } else {
      element.classList.remove("sp-part7-feature-active");
    }
  });

  if (part7MobileArrow && typeof part7MobileArrowTopList[index] !== "undefined") {
    part7MobileArrow.style.top = `${part7MobileArrowTopList[index]}px`;
  }
}

const part7MobileSwiper = new Swiper(".sp-part7.sp-mobile .sp-swiper-part7-mobile", {
  autoplay: {
    disableOnInteraction: false,
    delay: 3500,
  },
  loop: true,
  effect: "fade",
  speed: 600,
  on: {
    init(swiper) {
      setPart7MobileActive(swiper.realIndex);
    },
    slideChange(swiper) {
      setPart7MobileActive(swiper.realIndex);
    },
  },
});

part7MobileFeatureTitles.forEach((element, index) => {
  element.addEventListener("click", () => {
    part7MobileSwiper.slideToLoop(index);
    setPart7MobileActive(index);
  });
});

part7MobileFeatureDescs.forEach((element, index) => {
  element.addEventListener("click", () => {
    part7MobileSwiper.slideToLoop(index);
    setPart7MobileActive(index);
  });
});

$(".sp-part999 .sp-box .q-row").click(function () {
  const $item = $(this).closest(".sp-box-row");
  const $box = $item.parent();
  const $answer = $item.children(".sp-text");
  const $otherItems = $box.children(".sp-box-row").not($item);

  $otherItems.removeClass("sp-show");
  $otherItems.children(".sp-text").stop(true, true).slideUp(300);

  if ($item.hasClass("sp-show")) {
    $item.removeClass("sp-show");
    $answer.stop(true, true).slideUp(300);
  } else {
    $item.addClass("sp-show");
    $answer.stop(true, true).slideDown(300);
  }
});


// ========== 购物模块逻辑 ==========

//购物模块相关
/**倒计时 */

// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(
      cutDownTimeText.minute
    );
    $(".sp_top_cut_down .sp_left_view .sp_second").html(
      cutDownTimeText.second
    );
  }, 1000);
}

getCutDownTime();

const spTypeImages = [
  "https://cdn.shopify.com/s/files/1/0654/6332/0707/files/20260317-1-14-pc.png",
  "https://cdn.shopify.com/s/files/1/0654/6332/0707/files/20260317-1-142-pc.png",
  'https://cdn.shopify.com/s/files/1/0654/6332/0707/files/LT10331970_1.jpg?v=1774609087',
  'https://cdn.shopify.com/s/files/1/0654/6332/0707/files/LT10331970_2.jpg?v=1774609087',
  "https://cdn.shopify.com/s/files/1/0654/6332/0707/files/2026031801-pro.png",
  "https://cdn.shopify.com/s/files/1/0654/6332/0707/files/2026031802-pro.png"
];

function updateStyleImage() {
  const typeIndex = $("#sp-opt-group1 .sp-option.active").index();
  const colorIndex = $("#sp-opt-group2 .sp-option.active").index();
  // const colorIndex = 0;
  let _index = typeIndex + colorIndex * 2
  const imageSrc = spTypeImages[_index] || spTypeImages[0];
  $(".sp-img-p").attr("src", imageSrc);
}

// 样式选项点击事件（sp-opt-group1）
$("#sp-opt-group1 .sp-option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  updateStyleImage();
});
$("#sp-opt-group2 .sp-option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  updateStyleImage();
});

// 型号选项点击事件（sp-qty）
// $("#sp-opt-group2 .sp-option").click(function () {
//   $(this).siblings().removeClass("active");
//   $(this).addClass("active");
//   // 型号选项变化时，不改变图片
//   updateStyleImage()
// });

updateStyleImage();
let sp_price1 = 17.49;
let sp_price2 = 34.99;

  const $priceDom = $('#sp_price1');
  const $cPriceDom = $('#sp_price2');
  const $offPriceDom = $('.price-group .sp-p');
  const $numDom = $('#calcNumber');

  const productData = window.product || [];

  function changePrice() {
    const curVariant = getCur();
    if (!curVariant) return;

    const num = parseInt($numDom.val()) || 1;

    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim();
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);

    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.';
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0;

    // 格式化输出
    const formatValue = (cents) => {
      let val = (cents * num / 100).toFixed(decimalLength);
      if (decimalSeparator === ',') {
        val = val.replace('.', ',');
      }
      return val;
    };

    const price = formatValue(curVariant.price);
    const compare = formatValue(curVariant.compare_at_price);

    // 计算折扣
    let offPercent = 0;
    if (curVariant.compare_at_price > curVariant.price) {
      offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
    }

    const priceRegex = /\d+(?:[.,]\d+)*/;
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

    const updateHTML = ($el, regex, value) => {
      if ($el && $el.length) {
        const text = $el[0].textContent.trim();
        const newHtml = text.replace(regex, value);
        if ($el.html() !== newHtml) {
          $el.html(newHtml);
        }
      }
    };

    updateHTML($priceDom, priceRegex, price);
    updateHTML($cPriceDom, priceRegex, compare);
    updateHTML($offPriceDom, offRegex, offPercent);
  }

  /** 获取当前选中的变量 */
  function getCur() {
    const opts = {
      option1: $('#sp-opt-group1 div.active').attr('data-val'),
      option2: $('#sp-opt-group2 div.active').attr('data-val'),
      option3: $('#sp-opt-group3 div.active').attr('data-val')
    };

    return productData.find(item => {
      return (!opts.option1 || item.option1 == opts.option1) &&
        (!opts.option2 || item.option2 == opts.option2) &&
        (!opts.option3 || item.option3 == opts.option3);
    });
  }
function calcTotal(price, num) {
  let result = Number(price) * Number(num);
  return result.toFixed(2).replace('.', ',');
}
$(".sp-reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
  // $("#sp_price1").html('€' + calcTotal(sp_price1, input.value));
  // $("#sp_price2").html('€' + calcTotal(sp_price2, input.value));
  changePrice()
});
$(".sp-add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  // $("#sp_price1").html('€' + calcTotal(sp_price1, input.value));
  // $("#sp_price2").html('€' + calcTotal(sp_price2, input.value));
  changePrice()
});


// ========== 菜单模块逻辑 ==========
// 移动端菜单开关
$('.sp-menu-btn').click(function () {
  $('.sp-menu-mask').fadeIn();
});

$('.sp-close-btn, .sp-menu-mask').click(function (e) {
  if (e.target === this) {
    $('.sp-menu-mask').fadeOut();
  }
});

// 菜单项点击后关闭菜单
$('.sp-menu-item a').click(function () {
  $('.sp-menu-mask').fadeOut();
});
